import { render, staticRenderFns } from "./SmsGiphyItem.vue?vue&type=template&id=34136548&scoped=true&"
import script from "./SmsGiphyItem.vue?vue&type=script&lang=js&"
export * from "./SmsGiphyItem.vue?vue&type=script&lang=js&"
import style0 from "./SmsGiphyItem.vue?vue&type=style&index=0&id=34136548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34136548",
  null
  
)

export default component.exports